<style src="./ContentHeader.scss" lang="scss" scoped></style>
<template lang="html">
  <section class="content-header">
    <breadcrumb>
      <slot></slot>
    </breadcrumb>
  </section>
</template>

<script>
import Breadcrumb from './breadcrumb/Breadcrumb'

export default {
  name: 'ContentHeader',
  components: {
    Breadcrumb
  },
  props: {
    path: {
      default: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/foundation/content-header/ContentHeader.vue